import {
    UPDATE_PRE_RANK,
    UPDATE_FINAL_RANK,
    UPDATE_WINNERS
} from "../../../mutation-types";
import { assign } from "../../../../common/utils";

export default {
    [UPDATE_PRE_RANK](state, info) {
        const _preRank = state._preRank || {}

        // TODO: 等整理至api层
        info = assign({}, info)
        const {pageNum, total} = info
        info.maxPage = pageNum > 0 && total > 0 ? Math.ceil(total / pageNum) : 0

        _preRank[info.type] = info
        state._preRank = _preRank
    },

    [UPDATE_FINAL_RANK](state, info) {

        // TODO: 等整理至api层
        info = assign({}, info)
        const {pageNum, total} = info

        info.maxPage = pageNum > 0 && total > 0 ? Math.ceil(total / pageNum) : 0
        
        // console.log({total, info});
        state._finalRank = info
    },

    [UPDATE_WINNERS](state, info) {
        state._winners = info
    }
}
